import { createUseStyles } from 'react-jss'

export default createUseStyles({
  adPreview: {
    width: containerWidth => containerWidth,
    maxWidth: '100%',
    borderRadius: 9,
    overflow: 'hidden',
    margin: '0 auto 25px',

    '& img': {
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },

  footer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 95,
    background: '#fff',
    padding: 10,
    color: '#000'
  },

  footerTop: {
    fontSize: 12
  },
  footerBottom: {
    fontSize: 10
  }
})
